import { render, staticRenderFns } from "./student-detail.vue?vue&type=template&id=2368248c&scoped=true&"
import script from "./student-detail.vue?vue&type=script&lang=js&"
export * from "./student-detail.vue?vue&type=script&lang=js&"
import style0 from "./student-detail.vue?vue&type=style&index=0&id=2368248c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2368248c",
  null
  
)

component.options.__file = "student-detail.vue"
export default component.exports